(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yzly-ai-programs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('yzly-ai-programs')) {
  customElements.define('yzly-ai-programs', class extends HTMLElement {
    connectedCallback() {
      if (this._events) return;
      this._events = new AbortController();
      const signal = this._events.signal;
      this.addEventListener('click', (event) => this.handleClick(event), {signal});
      this.addEventListener('change', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement) || !target.checked) return;
        const announcement = this.querySelector('[data-yai-announcement]');
        if (!announcement) return;
        if (target.matches('.yai-family-radio')) {
          announcement.textContent = target.dataset.programName + ' selected. Choose a level below.';
        } else if (target.matches('.yai-level-radio')) {
          announcement.textContent = target.dataset.stageName + ' selected. Its learning journey and purchase details are shown below.';
        }
      }, {signal});
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const dialog = this.querySelector('dialog[open]');
        if (!dialog) return;
        const controls = Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(control => control.getClientRects().length);
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }, {signal});
    }

    disconnectedCallback() {
      if (this._events) this._events.abort();
      this._events = null;
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
    }

    handleClick(event) {
      if (!(event.target instanceof Element)) return;
      const opener = event.target.closest('[data-yai-open]');
      if (opener && this.contains(opener)) {
        const dialog = this.querySelector('[data-yai-dialog="' + opener.dataset.yaiOpen + '"]');
        if (dialog && typeof dialog.showModal === 'function') {
          event.preventDefault();
          opener.focus({preventScroll:true});
          if (!dialog.open) dialog.showModal();
        }
        return;
      }
      const closer = event.target.closest('[data-yai-close]');
      if (closer && this.contains(closer)) {
        const dialog = closer.closest('dialog');
        if (dialog) dialog.close();
        return;
      }
      const selector = event.target.closest('[data-yai-choose-program], [data-yai-view-selected]');
      if (selector && this.contains(selector)) {
        const value = selector.dataset.yaiChooseProgram;
        const radio = value ? this.querySelector('.yai-family-radio[value="' + value + '"]') : this.querySelector('.yai-family-radio:checked');
        if (!radio) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', {bubbles:true}));
        this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
        const panel = radio.nextElementSibling.nextElementSibling;
        const heading = panel.querySelector('[data-yai-program-heading]');
        if (heading && this.isConnected) {
          heading.focus({preventScroll:true});
          heading.scrollIntoView({behavior:'auto', block:'start'});
        }
        return;
      }
      if (event.target.tagName === 'DIALOG' && event.target.open) {
        const rect = event.target.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yzly-manager-fundamentals"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yzly-manager-fundamentals')) {
    customElements.define('yzly-manager-fundamentals', class extends HTMLElement {
      connectedCallback() {
        if (this._events) return;
        this._events = new AbortController();
        const signal = this._events.signal;
        this.addEventListener('click', (event) => this.handleClick(event), { signal });
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Tab') return;
          const dialog = this.querySelector('dialog[open]');
          if (!dialog) return;
          const controls = Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter((control) => control.getClientRects().length > 0);
          if (!controls.length) return;
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }, { signal });
        this.addEventListener('change', (event) => {
          if (!event.target.matches('.ymfc-radio') || !event.target.checked) return;
          const announcement = this.querySelector('[data-ymf-announcement]');
          if (announcement) announcement.textContent = event.target.dataset.kitName + ' selected. Its eight-workshop journey is shown below.';
        }, { signal });
      }

      disconnectedCallback() {
        if (this._events) this._events.abort();
        this._events = null;
        this.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
      }

      handleClick(event) {
        if (!(event.target instanceof Element)) return;
        const opener = event.target.closest('[data-ymf-open]');
        if (opener && this.contains(opener)) {
          const dialog = this.querySelector('[data-ymf-dialog="' + opener.dataset.ymfOpen + '"]');
          if (dialog && typeof dialog.showModal === 'function') {
            event.preventDefault();
            opener.focus({ preventScroll: true });
            if (!dialog.open) dialog.showModal();
          }
          return;
        }

        const closer = event.target.closest('[data-ymf-close]');
        if (closer && this.contains(closer)) {
          const dialog = closer.closest('dialog');
          if (dialog) dialog.close();
          return;
        }

        const journeyButton = event.target.closest('[data-ymf-show-journey], [data-ymf-view-selected]');
        if (journeyButton && this.contains(journeyButton)) {
          const value = journeyButton.dataset.ymfShowJourney;
          const radio = value ? this.querySelector('.ymfc-radio[value="' + value + '"]') : this.querySelector('.ymfc-radio:checked');
          if (!radio) return;
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          this.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
          const panel = radio.nextElementSibling.nextElementSibling;
          const heading = panel.querySelector('[data-ymf-journey-heading]');
          requestAnimationFrame(() => {
            if (!heading) return;
            heading.focus({ preventScroll: true });
            heading.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          });
          return;
        }

        if (event.target.tagName === 'DIALOG' && event.target.open) {
          const rect = event.target.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yzly-performance-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yzly-performance-reviews')) {
    customElements.define('yzly-performance-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this._events) return;
        this._events = new AbortController();
        const signal = this._events.signal;
        this.addEventListener('click', (event) => this.handleClick(event), { signal });
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Tab') return;
          const dialog = this.querySelector('dialog[open]');
          if (!dialog) return;
          const controls = Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter((control) => control.getClientRects().length > 0);
          if (!controls.length) return;
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }, { signal });
        this.addEventListener('change', (event) => {
          if (!event.target.matches('.ypr-radio') || !event.target.checked) return;
          const announcement = this.querySelector('[data-ypr-announcement]');
          if (announcement) announcement.textContent = event.target.dataset.kitName + ' selected. Its six-workshop journey is shown below.';
        }, { signal });
      }

      disconnectedCallback() {
        if (this._events) this._events.abort();
        this._events = null;
        this.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
      }

      handleClick(event) {
        if (!(event.target instanceof Element)) return;
        const opener = event.target.closest('[data-ypr-open]');
        if (opener && this.contains(opener)) {
          const dialog = this.querySelector('[data-ypr-dialog="' + opener.dataset.yprOpen + '"]');
          if (dialog && typeof dialog.showModal === 'function') {
            event.preventDefault();
            opener.focus({ preventScroll: true });
            if (opener.dataset.yprOpen === 'guide') {
              const frame = dialog.querySelector('[data-ypr-pdf-frame]');
              if (frame && !frame.hasAttribute('src') && window.matchMedia('(min-width: 601px)').matches) {
                frame.setAttribute('src', frame.dataset.src);
              }
            }
            if (!dialog.open) dialog.showModal();
          }
          return;
        }

        const closer = event.target.closest('[data-ypr-close]');
        if (closer && this.contains(closer)) {
          const dialog = closer.closest('dialog');
          if (dialog) dialog.close();
          return;
        }

        const journeyButton = event.target.closest('[data-ypr-show-journey], [data-ypr-view-selected]');
        if (journeyButton && this.contains(journeyButton)) {
          const value = journeyButton.dataset.yprShowJourney;
          const radio = value ? this.querySelector('.ypr-radio[value="' + value + '"]') : this.querySelector('.ypr-radio:checked');
          if (!radio) return;
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          this.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
          const panel = radio.nextElementSibling.nextElementSibling;
          const heading = panel.querySelector('[data-ypr-journey-heading]');
          requestAnimationFrame(() => {
            if (!heading) return;
            heading.focus({ preventScroll: true });
            heading.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          });
          return;
        }

        if (event.target.tagName === 'DIALOG' && event.target.open) {
          const rect = event.target.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
